
import React from 'react';
import { connect } from 'react-redux';
import { Registry } from 'react-registry';

import { ConditionTypeRegistry } from 'common/form/fields/condition/ConditionTypeRegistry';
import PageUtil from 'core/components/layout/PageUtil';
import Logger from 'core/util/Logger';
import PanelUtil from 'core/util/PanelUtil';
import { isEqual } from 'lodash';
import { IPanelProps } from '../decorators/Panel';
import { nDef } from '../util/TypeUtils';
import authRouteComponent from './layout/AuthRouteComponent';

/**
 * @overview: Looks up panel for a list of panel UUIDs then retrieves the
 * panel, class from the registry and creates react and elements for them.
 * Should not be used directly. See {@link ContainerPanel}, {@link LayoutPanel},
 * and {@link PagePanel} for how to use in configuration.
 *
 * @author: jesposito
 */

interface IContainerProps {
	children: string[];
	seperator?: React.ReactNode;
}

interface IContainerInnerProps {
	children: Array<IPanelProps<any>>;
	seperator?: React.ReactNode;
	editing?: boolean;
	location: any;
}

class CoreContainer extends React.Component<IContainerInnerProps> {

	public constructor(props: IContainerInnerProps) {
		super(props);
	}

	public shouldComponentUpdate(nextProps) {
		return !isEqual(this.props, nextProps);
	}

	public render(): any {
		let { children, editing, seperator } = this.props;

		if(nDef(children) || children.length <= 0) {
			return false;
		}

		// sort by sort index
		children = children.sort((a, b: IPanelProps<any>) => {
			return b.config.sortIndex;   // <== to compare string values
		});

		// Group pages and non page panels individually
		const { others, pages, pIndexes } = PageUtil.filterPages(children);

		// Retrieve non page panels from the registry
		const elements = others.map((c, i): any => {
			if(c) {
				const { id, instance } = c;

				// const panel = Registry.createElement({id, registry: "panels"}, {key: instance, instance, ...c, index: i});

				const panelClazz: any = Registry.get({id, registry: "panels"});

				if (!panelClazz) {
					Logger.error(`No panel found for id: ${id}`);
					return null;
				}

				const panelElement: any = React.createElement(panelClazz, {key: instance, instance, ...c, index: i});

				// only render the seperator if succeeding panel is visible to the user
				if(seperator && others[i + 1]) {
					return (
						<React.Fragment>
							{panelElement}
							{seperator}
						</React.Fragment>
					);
				}

				return panelElement;

				// if(edit && id !== "container") {
					// return [React.createElement(Controls, { instance, key: instance + "-controls"}), panel];
				// }

				// return panel;
			}
		});

		/// Pages present
		if(pages.length > 0) {

			// Group pages together into a react-router <Switch>
			

			const routerSwitch = authRouteComponent(pages, this.props.location, () => PageUtil.groupPages(pages, editing));

			// Insert page group into the original index of the 1st page
			elements.splice(pIndexes[0], 0, routerSwitch);
		}

		return elements;
	}
}

const mapStateToProps = (state, ownProps: IContainerProps): IContainerInnerProps => {
	const children = [];
	if (ownProps.children) {
		for (const instance of ownProps.children) {
			const config = state.config.panels[instance];

			if (!config) {
				continue;
			}

			if (!PanelUtil.isAccessible(config, state)) {
				continue;
			}

			children.push({id: config.id, instance, config});
		}
	}
	return { ...ownProps, children, editing: state.edit.enabled, location: state.router.location };
};

export default connect(mapStateToProps)(CoreContainer as any);



// WEBPACK FOOTER //
// ./src/core/components/CoreContainer.tsx